import UserPartnerAccountsTable from './UserPartnerAccountsTable';

export default UserPartnerAccountsTable;
